import { BoxTransfersRequestType } from '../interfaces';

export const boxTransfersEndpointMap: Record<BoxTransfersRequestType, string> = {
  [BoxTransfersRequestType.BRANCH]: '/api/admin/containers-transfers',
  [BoxTransfersRequestType.DECLARATION]: '/api/admin/containers-transfers/by-declaration',
  [BoxTransfersRequestType.CONTAINER]: '/api/admin/containers-transfers/by-container',
};
